import React, {memo} from "react";
// local
import {formatCompanyNumber} from "helpers/helper";
import {CustomTooltip} from "components/CustomTooltip";
import {IconCloseRound} from "components/icons";
import {color} from "constants/color.consts";
import cn from "classnames";

const baseClass = "signing_contract__data__company-info-tag";

export const SignContractCompanyInfoTag = memo(
  ({number, name, bordered, numberAsTooltip, onClose, addClass}) =>
    numberAsTooltip ? (
      <CustomTooltip text={formatCompanyNumber(number)}>
        <div className={`${baseClass}${bordered ? " inner" : ""}`}>
          <div>{name}</div>
        </div>
      </CustomTooltip>
    ) : (
      <div className={cn(baseClass, {inner: !!bordered, [addClass]: addClass})}>
        <div className={`${baseClass}-number`}>{formatCompanyNumber(number)}</div>
        <div>{name}</div>
        {onClose && (
          <IconCloseRound
            color={color.black}
            onClick={onClose}
            addClass="ml-2 cpointer"
          />
        )}
      </div>
    )
);
